"use strict";

const UserRoles = function () {
  /*
    Mirrors API UserRole@$roles
  */
  const permissions = {
    canEditAsset: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": true,
      responder: false,
      viewer: false,
      planner: false,
      server: true,
    },
    canDeleteAsset: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": false,
      responder: false,
      viewer: false,
      planner: false,
      server: true,
    },
    canInspectAsset: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": true,
      responder: false,
      viewer: false,
      planner: false,
      server: true,
    },
    canEditTodoList: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": false,
      responder: false,
      viewer: false,
      planner: false,
      server: false,
    },
    canPrioritizeTasks: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": false,
      responder: false,
      viewer: false,
      planner: false,
      server: true,
    },
    isFirmAffiliated: {
      admin: false,
      "data-manager": false,
      reviewer: false,
      "field-personnel": false,
      responder: true,
      viewer: false,
      planner: false,
      server: false,
    },
    isRoleLimitedAccess: {
      admin: false,
      "data-manager": false,
      reviewer: true,
      "field-personnel": false,
      responder: false,
      viewer: false,
      planner: false,
      server: false,
    },
    hasPermissionByProjectContact: {
      admin: false,
      "data-manager": false,
      reviewer: true,
      "field-personnel": false,
      responder: true,
      viewer: false,
      planner: false,
      server: false,
    },
    canCreateEnforcement: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": true,
      responder: false,
      viewer: false,
      planner: false,
      server: true,
    },
    canEditEnforcement: {
      admin: true,
      "data-manager": true,
      reviewer: true,
      "field-personnel": true,
      responder: false,
      viewer: false,
      planner: false,
      server: true,
    },
    canRespondToEnforcement: {
      admin: false,
      "data-manager": false,
      reviewer: false,
      "field-personnel": false,
      responder: true,
      viewer: false,
      planner: false,
      server: false,
    },
    canResolveEnforcement: {
      admin: true,
      "data-manager": false,
      reviewer: false,
      "field-personnel": false,
      responder: false,
      viewer: false,
      planner: false,
      server: true,
    },
    canReviewDeferrals: {
      admin: true,
      "data-manager": false,
      reviewer: true,
      "field-personnel": false,
      responder: false,
      viewer: false,
      planner: false,
      server: true,
    },
    canCreateProjects: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": true,
      responder: false,
      viewer: false,
      planner: true,
      server: true,
    },
    canExportData: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": true,
      responder: false,
      viewer: true,
      planner: true,
      server: true,
    },
    canAdvanceProjects: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": false,
      responder: false,
      viewer: false,
      planner: false,
      server: true,
    },
    canCertifyProjects: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": true,
      responder: false,
      viewer: false,
      planner: false,
      server: true,
    },
    canCreateBmps: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": true,
      responder: false,
      viewer: false,
      planner: true,
      server: true,
    },
    canCreateDryWeatherScreenings: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": true,
      responder: false,
      viewer: false,
      planner: false,
      server: true,
    },
    canDeleteDryWeatherScreenings: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": false,
      responder: false,
      viewer: false,
      planner: false,
      server: true,
    },
    canDeleteInspections: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": false,
      responder: false,
      viewer: false,
      planner: false,
      server: false,
    },
    canEditRoads: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": false,
      responder: false,
      viewer: false,
      planner: false,
      server: false,
    },
    canManageApiKeys: {
      admin: true,
      "data-manager": false,
      reviewer: false,
      "field-personnel": false,
      responder: false,
      viewer: false,
      planner: false,
      server: true,
    },
    canManageUsers: {
      admin: true,
      "data-manager": false,
      reviewer: false,
      "field-personnel": false,
      responder: false,
      viewer: false,
      planner: false,
      server: true,
    },
    canManageEswftSync: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": true,
      responder: false,
      viewer: false,
      planner: false,
      server: true,
    },
    canManageTasks: {
      admin: true,
      "data-manager": false,
      reviewer: false,
      "field-personnel": false,
      responder: false,
      viewer: false,
      planner: false,
      server: true,
    },
    canCreateOutfall: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": true,
      responder: false,
      viewer: false,
      planner: true,
      server: false,
    },
    canCreateRecordSweeps: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": true,
      responder: false,
      viewer: false,
      planner: false,
      server: false,
    },
    canCreateIncident: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": true,
      responder: false,
      viewer: false,
      planner: false,
      server: false,
    },
    canDeleteIncident: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": false,
      responder: false,
      viewer: false,
      planner: false,
      server: false,
    },
    canEditIncident: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": true,
      responder: false,
      viewer: false,
      planner: true,
      server: false,
    },
    canCreateIncidentInvestigation: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": true,
      responder: false,
      viewer: false,
      planner: false,
      server: false,
    },
    canCreateActivity: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": true,
      responder: false,
      viewer: false,
      planner: true,
      server: true,
    },
    canDeleteActivity: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": true,
      responder: false,
      viewer: false,
      planner: false,
      server: true,
    },
    canCreateFacility: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": true,
      responder: false,
      viewer: false,
      planner: false,
      server: true,
    },
    canRunTelr: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": false,
      responder: false,
      viewer: false,
      planner: false,
      server: false,
    },
    canCreatePlan: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": false,
      responder: false,
      viewer: false,
      planner: false,
      server: true,
    },
    canCreateProperty: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": false,
      responder: false,
      viewer: false,
      planner: false,
      server: true,
    },
    canCreateSamplingSite: {
      admin: true,
      "data-manager": true,
      reviewer: false,
      "field-personnel": true,
      responder: false,
      viewer: false,
      planner: true,
      server: false,
    },
  };

  const permissionMap = {
    can_create_bmps: "canCreateBmps",
    can_delete_bmps: "canDeleteAsset",
    can_create_enforcement: "canCreateEnforcement",
    can_inspect_facility: "canInspectAsset",
    can_edit_facility: "canEditAsset",
    can_issue_facility_enforcement: "canCreateEnforcement",
    can_issue_lid_enforcement: "canCreateEnforcement",
    can_issue_incident_enforcement: "canCreateEnforcement",
    can_create_incident_investigation: "canCreateIncidentInvestigation",
    possibly_edit_bmp: "canEditAsset",
    possibly_edit_project: "canEditAsset",
    can_create_projects: "canCreateProjects",
    can_delete_projects: "canDeleteAsset",
    can_create_outfall: "canCreateOutfall",
    can_delete_outfall: "canDeleteAsset",
    can_edit_outfall: "canEditAsset",
    can_create_sampling_site: "canCreateSamplingSite",
    can_edit_sampling_site: "canEditAsset",
    can_delete_sampling_site: "canDeleteAsset",
    can_create_activity: "canCreateActivity",
    can_delete_activity: "canDeleteActivity",
    can_create_facility: "canCreateFacility",
    can_delete_facility: "canDeleteAsset",
    can_create_plan: "canCreatePlan",
    can_run_telr: "canRunTelr",
    can_edit_pipe: "canEditAsset",
    can_edit_manhole: "canEditAsset",
    can_edit_culvert: "canEditAsset",
    can_edit_open_channel: "canEditAsset",
    can_edit_lift_station: "canEditAsset",
    can_edit_cleanout: "canEditAsset",
  };

  /**
   * This should contain only configurations for presentation that couldn't
   * easily go in the backend.
   */
  const userConfig = {
    // AKA Super Admin, Module Admin
    admin: {
      showFormalCommunications: true,
      showResponseNeeded: true,
      showMissingInformation: true,
      managers: true,
      inventory: true,
      canAssignTodos: true,
    },
    // AKA Program Manager, Module Data Manager
    "data-manager": {
      showFormalCommunications: true,
      showResponseNeeded: true,
      showMissingInformation: true,
      managers: true,
      inventory: true,
      canAssignTodos: true,
    },
    // AKA Module Reviewer (PE)
    reviewer: {
      showProjectEnforcementActionsTodos: true,
      showProjectInspectionTodos: false,
      showCompleteProjectTodos: false,
      showBmpInstallationTodos: false,
      showDeferralReviewButtons: true,
    },
    viewer: {
      showDeferEnforcementButton: false,
      showProjectEnforcementActionsTodos: false,
      showProjectInspectionTodos: false,
      showCompleteProjectTodos: false,
      showBmpInstallationTodos: false,
    },
    "field-personnel": {
      showProjectInspectionTodos: ["can_inspect_projects"],
      showCompleteProjectTodos: ["can_certify_projects", "can_inspect_projects"],
      showBmpInstallationTodos: ["can_certify_projects"],
      showMissingInformation: true,
      inventory: true,
      canAssignTodos: true,
    },
    "editing-project-contact": {},
    responder: {
      showDeferEnforcementButton: true,
      showProjectEnforcementActionsTodos: false,
      showProjectInspectionTodos: false,
      showCompleteProjectTodos: false,
      showBmpInstallationTodos: false,
    },
    planner: {
      showProjectEnforcementActionsTodos: false,
    },
  };

  /*
   * You shouldn't necessarily always set a default for a config. Leave the
   * default out to have developer to decide on the config manually.
   */
  const configDefaults = {
    showDeferEnforcementButton: false,
    showDeferralReviewButtons: false,
    showProjectEnforcementActionsTodos: true,
    showProjectInspectionTodos: true,
    showCompleteProjectTodos: true,
    showBmpInstallationTodos: true,
    showFormalCommunications: false,
    showResponseNeeded: false,
    showMissingInformation: false,
    managers: false,
    inventory: false,
    canAssignTodos: false,
  };

  var getConfigForUser = function (key, user = Session.getCurrentUserObject()) {
    const role = user.userRole;
    const config = userConfig[role]?.[key];

    if (Array.isArray(config)) {
      return config.some((permission) => user.permissions[permission]);
    } else if (config !== undefined) {
      return config;
    } else if (configDefaults[key] !== undefined) {
      return configDefaults[key];
    } else {
      throw new Error(
        `The config ${key} is not set for the ${role} role and it doesn't have a default.`,
      );
    }
  };

  var getConfig = function (key) {
    return getConfigForUser(key, Session.getCurrentUserObject());
  };

  var getRole = function () {
    return Tree.get("user", "user_role");
  };

  var getRolePermissionForUser = function (permission, userRole = getRole()) {
    const permissionConfig = permissions[permission] ?? permissions[permissionMap[permission]];

    if (permissionConfig === undefined) {
      throw new Error(`Unknown permission "${permission}"`);
    }

    const hasPermission = permissionConfig[userRole];

    if (hasPermission === undefined) {
      throw new Error(`Unknown role "${userRole}" for permission "${permission}"`);
    }

    return hasPermission;
  };

  var getPermissionsForRole = function (role) {
    const rolePermissions = {};

    for (const [frontendKey, backendKey] of Object.entries(permissionMap)) {
      const permission = permissions[backendKey][role];

      if (permission === undefined) {
        throw new Error(`Unknown role "${role}" for permission "${backendKey}"`);
      }

      rolePermissions[frontendKey] = permission;
    }

    return rolePermissions;
  };

  return {
    getRole,
    getConfig,
    getConfigForUser,
    getPermissionsForRole,
    getRolePermissionForUser,
  };
};

module.exports = UserRoles();

const Tree = require("../tree");
const Session = require("./session");
